
import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './RoundedImageIcon.icss'
import getImageSrcByResolution from '../utilities/getImageSrcByResolution'

class RoundedImageIcon extends React.Component {
	render() {
		const imgSrc = getImageSrcByResolution(this.props)
		return 	(
			<div
				className={classnames(this.props.className, styles.roundedImageIcon, (this.props.cover ? styles.cover : null))}
				style={{ backgroundImage: `url(${imgSrc})` }}
			/>
		)
	}
}

RoundedImageIcon.propTypes = {
	cover: PropTypes.bool,
	className: PropTypes.string
}

RoundedImageIcon.defaultProps = {
	cover: false,
	className: undefined
}

export default RoundedImageIcon



// WEBPACK FOOTER //
// ./src/components/RoundedImageIcon.jsx